/**
 * Created by manoraj.k on 17/08/17.
 */
import styled from "styled-components";
import {colors} from "../../colorCodes.js"

export const SectionHeader = styled.div`
    width: 100%;
    height: auto;
    background: ${colors.whiteText};
    padding: 20px 25px;
    box-shadow: 0 2px 4px 0 rgba(218,218,218,0.5);
    font-size: 12px;
    font-family: Arial;
    box-sizing: border-box;
    ul {
    margin: 0px;
    padding: 0px;
    }
    ul li {
        display: inline-block;
        &:after {
            content: ">";
            display: inline-block;
            width: 20px;
            text-align: center;
            color: grey;
        }
        a {
            cursor: pointer;
            color: ${colors.activeBreadCrumbColor};
            text-decoration: none;
        }
        &:last-child {
            a {
                color: grey;
                cursor: auto;
                text-decoration: none;
            }
            &:after {
                content: "";
                display: "none"
            }
        }
    }
    .section-link {

    }
    `

export const SectionTitle = styled.div`
    color: ${colors.titleBlack};
    font-family: 'Riona Sans Light', sans-serif;
    font-size: 21px;
    margin-top: 10px;
    display: inline-block;
    `